// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/totesPage/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/totesPage/deleteTote */
export const useDeleteTote = makeBackendHook('totesPage', 'deleteTote')
